import classes from './MonthlyForm.module.scss';
import { Calendar, CalendarProps } from 'primereact/calendar';
import { useTranslation } from 'react-i18next';
import { defaultCronObject, Props } from '../CrontabView';
import { useEffect } from 'react';

const MonthlyForm = ({ onCronChanged, date }: Props) => {

  const { t: translate } = useTranslation();
  const lang = navigator.language.split('-')[0];

  useEffect(() => {
    onCronChanged({
      ...defaultCronObject,
      minutes: date.getMinutes().toString(),
      hours: date.getHours().toString(),
      dayMonth: date.getDate().toString()
    });
  }, []);

  const onHourChangedHandler = (val: CalendarProps) => {
    const tmpDate = val.value as Date;
    onCronChanged({
      ...defaultCronObject,
      dayMonth: date.getDate().toString(),
      hours: tmpDate.getHours().toString(),
      minutes: tmpDate.getMinutes().toString(),
    });
  };

  const onDayChangedHandler = (val: CalendarProps) => {
    const tmpDate = val.value as Date;

    onCronChanged({
      ...defaultCronObject,
      dayMonth: tmpDate.getDate().toString().padStart(2, '0'),
      hours: date.getHours().toString().padStart(2, '0'),
      minutes: date.getMinutes().toString().padStart(2, '0'),
    });
  };

  return (
    <>
      <div className={ classes['form-control'] }>
        <label>{ translate('cron-tab.input.on') }</label>
        <Calendar
          locale={ lang }
          showIcon
          dateFormat="dd"
          value={ date }
          onChange={ onDayChangedHandler }
        />
      </div>
      <div className={ classes['form-control'] }>
        <label>{ translate('cron-tab.input.at') }</label>
        <Calendar
          showIcon
          showTime
          icon="pi pi-clock"
          timeOnly
          hourFormat="24"
          value={ date }
          onChange={ onHourChangedHandler }
        />
      </div>
    </>
  );
};

export default MonthlyForm;